import { useId } from "react";

const BID_PACKAGE_PATH =
  "M17.9383 7.94714C12.3055 7.94714 7.73828 12.5144 7.73828 18.1471C7.73828 23.7799 12.3055 28.3471 17.9383 28.3471C23.571 28.3471 28.1382 23.7799 28.1382 18.1471C28.1382 12.5144 23.571 7.94714 17.9383 7.94714ZM17.9383 26.6168C13.2618 26.6168 9.46864 22.8236 9.46864 18.1471C9.46864 13.4706 13.2618 9.6775 17.9383 9.6775C22.6148 9.6775 26.4079 13.4706 26.4079 18.1471C26.4079 22.8236 22.6148 26.6168 17.9383 26.6168ZM19.0243 17.6189L18.446 17.4846V14.4269C19.3112 14.5453 19.8462 15.0871 19.9373 15.752C19.9487 15.843 20.0261 15.909 20.1171 15.909H21.1394C21.2464 15.909 21.3307 15.8157 21.3216 15.7087C21.1827 14.2903 20.0147 13.3795 18.4551 13.2224V12.4779C18.4551 12.3778 18.3731 12.2958 18.273 12.2958H17.6332C17.533 12.2958 17.451 12.3778 17.451 12.4779V13.2293C15.8391 13.3864 14.5777 14.2766 14.5777 15.9386C14.5777 17.4778 15.7116 18.22 16.9023 18.5046L17.4647 18.648V21.897C16.4584 21.7627 15.8937 21.2253 15.7776 20.5013C15.7639 20.4148 15.6865 20.351 15.5977 20.351H14.5459C14.4388 20.351 14.3546 20.4421 14.3637 20.5491C14.4662 21.8014 15.4156 22.9534 17.4419 23.1014V23.8163C17.4419 23.9165 17.5239 23.9985 17.6241 23.9985H18.2707C18.3709 23.9985 18.4528 23.9165 18.4528 23.814L18.4483 23.0923C20.231 22.9352 21.506 21.9812 21.506 20.2691C21.5037 18.689 20.4996 17.9832 19.0243 17.6189ZM17.4624 17.2501C17.3349 17.2136 17.2279 17.1795 17.1209 17.1362C16.3513 16.8585 15.9939 16.4099 15.9939 15.8316C15.9939 15.0052 16.62 14.5339 17.4624 14.4269V17.2501ZM18.446 21.9038V18.8598C18.5166 18.8802 18.5803 18.8962 18.6463 18.9098C19.7233 19.2377 20.0853 19.6931 20.0853 20.392C20.0853 21.2823 19.4159 21.8173 18.446 21.9038Z";

/**
 * Bid Package (Buyout) glyph — dollar coin, no tile. A filled shape, so the
 * colour comes from a `fill-*` class in `className`.
 */
export default function BidPackageCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="7.24 7.45 21.4 21.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d={BID_PACKAGE_PATH} fillOpacity={opacity} />
    </svg>
  );
}

/**
 * Bid Package badge — the same coin on its fixed-colour tile.
 * Design: 36×36 container (#FFB64F) + glyph (#B85C16). Used by CiqIconBox.
 */
export function BidPackageTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  // Per-instance id so several badges on one page don't share a clipPath.
  const clipId = `bid-package-clip-${useId().replace(/:/g, "")}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#FFB64F" />
      <g clipPath={`url(#${clipId})`}>
        <path d={BID_PACKAGE_PATH} fill="#B85C16" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="20.4"
            height="20.4"
            fill="white"
            transform="translate(7.73828 7.94714)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
